import {Injectable} from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  short_label?: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MENUITEMS = [
  {
    label: '',
    main: [
      {
        state: 'dashboard',
        short_label: 'N',
        name: 'Dashboard',
        type: 'link',
        icon: 'feather icon-settings',
        allowed_roles: ['*']
      },
      {
        state: 'assets',
        short_label: 'W',
        name: 'Assets',
        type: 'sub',
        icon: 'fas fa-truck-moving',
        badge: [
          {
            type: 'danger',
            value: '10+'
          }
        ],
        children: [
          {
            state: 'buses',
            name: 'Buses'
          }
        ],
        allowed_roles: ['*']
      }
    ],
  },
  {
    label: '',
    main: [
      {
        state: 'locations',
        short_label: 'A',
        name: 'Locations',
        type: 'link',
        icon: 'fa fa-map-marker',
        allowed_roles: ['*']
      }
    ]
  },
  {
    label: '',
    main: [
      {
        state: 'routes',
        short_label: 'A',
        name: 'Routes',
        type: 'link',
        icon: 'feather icon-aperture rotate-refresh',
        allowed_roles: ['*']
      }
    ]
  },
  {
    label: '',
    main: [
      {
        state: 'customers',
        short_label: 'A',
        name: 'Customers',
        type: 'link',
        icon: 'fa fa-address-book',
        allowed_roles: ['SUPER_ADMIN', 'ADMIN']
      }
    ]
  },
  {
     label: '',
     main: [
       {
         state: 'schedule-trips',
         short_label: 'A',
         name: 'Schedule Trips',
         type: 'link',
         icon: 'far fa-clock',
         allowed_roles: ['*']
       }
     ]
   },
  {
    label: '',
    main: [
      {
        state: 'shipments',
        short_label: 'S',
        name: 'Shipments',
        type: 'sub',
        icon: 'far fa-clock',
        children: [
          {
            state: 'consignments',
            name: 'Bookings'
          },
          {
            state: 'schedule',
            name: 'Schedule Shipments'
          },
          {
            state: 'trips',
            name: 'Trips'
          }
    
        ],
        allowed_roles: ['*']
      }
    ]
  },
  {
    label: '',
    main: [
      {
        state: 'companies',
        short_label: 'A',
        name: 'Companies',
        type: 'link',
        icon: 'fas fa-city',
        allowed_roles: ['SUPER_ADMIN']
      }
    ]
  },
  {
    label: '',
    main: [
      {
        state: 'analytics',
        short_label: 'A',
        name: 'Analytics',
        type: 'link',
        icon: 'fas fa-chart-bar',
        allowed_roles: ['SUPER_ADMIN', 'ADMIN']
      }
    ]
  },
  {
    label: '',
    main: [
      {
        state: 'users',
        short_label: 'U',
        name: 'Users',
        type: 'sub',
        icon: 'feather icon-users',
        children: [
          {
            state: 'users',
            name: 'Users'
          }
          // , {
          //   state: 'drivers',
          //   name: 'Drivers'
          // }
        ],
        allowed_roles: ['SUPER_ADMIN', 'ADMIN']
      }
    ]
  },
  {
    label: '',
    main: [
      {
        state: 'devices',
        short_label: 'A',
        name: 'Devices',
        type: 'link',
        icon: 'fas fa-mobile-alt',
        allowed_roles: ['SUPER_ADMIN', 'ADMIN']
      }
    ]
  },
  {
    label: '',
    main: [
      {
        state: 'settings',
        short_label: 'S',
        name: 'Settings',
        type: 'link',
        icon: 'fas fa-cog',
        allowed_roles: ['ADMIN']
      }
    ]
  }
];


@Injectable()
export class MenuItems {

  FORMATED_ITEMS:any = {};

  getAll(): Menu[] {
    return MENUITEMS;
  }

  setAssets(vehicletypes) {
    let assets = [];
    this.FORMATED_ITEMS = {};
    for(var i in vehicletypes){
      if(vehicletypes[i].subtypes && vehicletypes[i].subtypes.length > 0){
        let type_name = vehicletypes[i].name?vehicletypes[i].name:"";
        if(type_name){
          let childs = [], routes = [];
          for(var j in vehicletypes[i].subtypes){
            let subtype = vehicletypes[i].subtypes[j];
            if(subtype){
              childs.push({
                state: this.formatState(subtype),
                name: subtype
              });
            }
          }

          if(childs.length > 0) {
            assets.push({
              state: this.formatState(type_name),
              name: type_name,
              type: 'sub',
              children: childs
            });
          }
        }
      }
    }
    MENUITEMS[0].main[1]["children"] = assets;
  }

  formatState(str) {
    var fItem = str?str.replace(/\s+/g, '-').toLowerCase():"";
    if(fItem){
      this.FORMATED_ITEMS[fItem] = str;
    }
    return fItem;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/menu-items/menu-items.ts